import { render, staticRenderFns } from "./CustomDashboards.vue?vue&type=template&id=4a8b4626"
import script from "./CustomDashboards.vue?vue&type=script&lang=ts"
export * from "./CustomDashboards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports